import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import './style.css';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

const TableContainer = styled.div`
  background-color: ${(props) =>
    props.backgroundTable ? props.backgroundTable : 'white'};

  .rt-noData {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    width: 100%;
    height: 100%;
    text-align: center;
  }
`;

const Table = (props) => {
  return (
    <TableContainer backgroundTable={props.backgroundTable}>
      <ReactTable
        noDataText={I18n.t('noDataTextTable')}
        showPagination={false}
        className="-striped"
        minRows={0}
        subRowsKey="children"
        sortable={false}
        resizable={false}
        defaultPageSize={props.defaultPageSize ? props.defaultPageSize : 500}
        {...props}
      />
    </TableContainer>
  );
};

export default React.memo(Table);
